export default {
  'menu.welcome': 'ようこそ',
  'menu.home': 'ホーム',
  'menu.login': 'ログイン',

  // システム管理モジュール
  'menu.system': 'システム管理',
  'menu.system.welcome': 'システムホーム',
  'menu.system.dict': '辞書管理',
  'menu.system.menu': 'メニュー管理',
  'menu.system.role': 'ロール管理',
  'menu.system.noAuth': '認証不要インターフェース',

  // イベント管理モジュール
  'menu.event': 'イベント管理',
  'menu.event.eventRecord': 'イベント記録',
  'menu.event.eventOrder': 'イベントオーダー',
  'menu.event.eventOrderNode': 'オーダーノード',
  'menu.event.eventReceiver': 'イベント受信者',
  'menu.event.resourceFile': 'リソースファイル',

  // 組織管理モジュール
  'menu.organization': '組織管理',
  'menu.organization.orgDept': '部署管理',
  'menu.organization.orgPost': 'ポジション管理',
  'menu.organization.orgTree': '組織構造',
  'menu.organization.employee': '従業員管理',

  // デバイス管理モジュール
  'menu.device': 'デバイス管理',
  'menu.device.deviceModel': 'デバイスモデル',
  'menu.device.deviceSupplier': 'デバイスサプライヤー',
  'menu.device.deviceGateway': 'デバイスゲートウェイ',
  'menu.device.deviceTerminal': 'デバイスターミナル',
  'menu.device.deviceManagement': 'デバイス管理',

  // パッケージ管理モジュール
  'menu.package': 'パッケージ管理',
  'menu.package.myPackage': 'マイパッケージ',
  'menu.package.subPackage': '子パッケージ',

  // ユーザー管理
  'menu.user': 'ユーザー管理',

  // ビデオ融合モジュール
  'menu.video': 'ビデオ融合',
  'menu.video.preview': 'リアルタイムプレビュー',
  'menu.video.playback': '履歴再生',
  'menu.video.recording': '手動録画',
};
